/* custom-gift-quiz.js — Geschenkefinder UI for sections/custom-gift-quiz.liquid.
 * Recommendation rules live in custom-gift-quiz-engine.js (Lise's reference engine, unchanged).
 * Copy, including the result profile sentence, comes from the section settings and
 * "Produkttext" blocks; product data from the section's product list (live prices),
 * with /products/<handle>.js as fallback.
 * See CUSTOM_CHANGES.md v0.0.12 and v0.0.15.
 */
(function () {
  'use strict';

  var HANDLES = {"All In Set":"all-in-set","Bag":"bag","Base":"stapelstein-base","Board":"board","Dynamic all":"stapelstein-dynamic-all","Dynamic all unique":"stapelstein-dynamic-all-unique-modularer-hocker-fur-bewegung-konzentration-in-jedem-alter","Dynamic complete":"stapelstein-dynamic-complete","Dynamic small":"stapelstein-dynamic-small","Fitness Bundle":"fitness-bundle","Inside 6 unique":"inside-6-unique","Inside Set":"inside-set","Inside Set small":"inside-set-small","Inside cool / warm":"inside-warm","Inside rainbow":"inside-rainbow","Mat":"mat","Original":"original","Original 3":"original-3","Original 3 unique":"original-3-unique","Original Grow":"original-grow","Original Grow duo":"original-grow-duo","Original Mini":"original-mini","Original Mini rainbow":"original-mini-rainbow","Original Rainbow (6)":"original-rainbow","Pad":"pad","Rainbow Set (7, avec Board)":"rainbow-set","Rolling Discs":"stapelstein-rolling-discs","Unique Set":"unique-set","Water play Set":"water-play-set","Waters and Greens Set (2+1)":"waters-and-greens-set-2-1","X Blackroll Bundle":"stapelstein®-x-blackroll®-bundle"};
  var HANDLES_WS = {"Board":"stapelstein®-winter-special-board-red-rose","Dynamic all":"stapelstein®-winter-special-dynamic-all","Dynamic complete":"stapelstein®-winter-special-dynamic-complete","Dynamic small":"stapelstein®-winter-special-dynamic-small","Inside Set small":"stapelstein®-winter-special-inside-set","Original":"stapelstein®-winter-special-original-violet","Original Grow":"stapelstein®-winter-special-original-grow-violet","Original Grow duo":"stapelstein®-winter-special-grow-duo","Original Mini rainbow":"stapelstein®-winter-special-mini-rainbow","Rainbow Set (7, avec Board)":"stapelstein®-winter-special-rainbow-set","Water play Set":"stapelstein®-winter-special-water-play-set"};
  /* Thumbnails for step 5, in the order of engine.own */
  var OWN_IMG = ["rainbow-set","all-in-set","original-rainbow","original-3","original","original-mini-rainbow","board","original-grow","stapelstein-dynamic-all","inside-rainbow","stapelstein-dynamic-small","stapelstein-base","inside-set","water-play-set","original-grow-duo","inside-set-small","mat",null,"fitness-bundle","stapelstein-dynamic-complete"];

  /* Short slugs for customer tags and the cart attribute. Not storefront copy. */
  var SLUG = {"Mon enfant ou mes enfants":"kind","Mes petits-enfants":"enkel","Filleul·e, nièce, neveu":"patenkind","Enfant d'ami·es":"freunde","Une personne adulte":"erwachsen","jusqu'à 100 €":"bis-100","100 à 200 €":"100-200","200 à 300 €":"200-300","plus de 300 €":"ueber-300","Bouger":"bewegen","Jouer":"spielen","S'asseoir":"sitzen","À emporter":"unterwegs","Dehors, au jardin":"draussen","Bureau":"schreibtisch","Sport / fitness":"sport","Yoga":"yoga","Équilibre":"balance","Salon":"wohnzimmer"};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function berlinToday() { try { return new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Berlin'}).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } }
  function partsOf(p) { return p.split(' + ').map(function (x) { var m = x.match(/^(\d) (.*)$/); return m ? {n: m[2], q: +m[1]} : {n: x, q: 1}; }); }
  function readJSON(root, sel) { var el = root.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }

  function init(root) {
    if (root._gq) return;
    root._gq = true;
    var C = readJSON(root, '[data-gq-config]') || {};
    var T = C.copy || {};
    /* Profile sentence. Empty settings fall back to the German sentence so a
       blank field does not collapse the line. Prefixes keep a trailing space
       even if the theme editor trims one. Phrases that do not start with the
       prefix are joined whole, which is what other languages need. */
    function phrase(key, fallback) {
      var v = T[key];
      return (v == null || v === '') ? fallback : v;
    }
    function wordPrefix(p) {
      if (!p) return '';
      return /\s$/.test(p) ? p : p + ' ';
    }
    var AND = phrase('prof_and', 'und');
    var PRE_ZUM = wordPrefix(phrase('prof_pre_zum', 'zum '));
    var PRE_FUER = wordPrefix(phrase('prof_pre_fuer', 'für '));
    function listJoin(a) {
      if (!a || a.length < 2) return (a && a[0]) || '';
      return a.slice(0, -1).join(', ') + ' ' + AND + ' ' + a[a.length - 1];
    }
    var FUER_ONE = {
      0: phrase('prof_one_0', 'Für ein Kind unter 1 Jahr'),
      1: phrase('prof_one_1', 'Für ein Kind von 1 bis 2 Jahren'),
      3: phrase('prof_one_3', 'Für ein Kind von 3 bis 5 Jahren'),
      6: phrase('prof_one_6', 'Für ein Kind von 6 bis 9 Jahren')
    };
    var FUER_MANY = {
      0: phrase('prof_many_0', 'Für mehrere Kinder, darunter ein Baby'),
      1: phrase('prof_many_1', 'Für mehrere Kinder ab 1 Jahr'),
      3: phrase('prof_many_3', 'Für mehrere Kinder ab 3 Jahren'),
      6: phrase('prof_many_6', 'Für mehrere Kinder ab 6 Jahren')
    };
    var ZWECK_LONG = {
      'Bouger': phrase('prof_l_bew', 'zum Bewegen, Klettern und Balancieren'),
      'Jouer': phrase('prof_l_spiel', 'zum Spielen, Bauen und Sortieren'),
      "S'asseoir": phrase('prof_l_sitz', 'zum Sitzen'),
      'À emporter': phrase('prof_l_mit', 'für unterwegs'),
      'Dehors, au jardin': phrase('prof_l_drauss', 'für draußen'),
      'Bureau': phrase('prof_l_buero', 'für den Schreibtisch'),
      'Sport / fitness': phrase('prof_l_sport', 'für Sport und Fitness'),
      'Yoga': phrase('prof_l_yoga', 'für Yoga und Dehnen'),
      'Équilibre': phrase('prof_l_bal', 'zum Balancieren'),
      'Salon': phrase('prof_l_wohn', 'fürs Wohnzimmer')
    };
    var ZWECK_SHORT = {
      'Bouger': phrase('prof_s_bew', 'zum Bewegen'),
      'Jouer': phrase('prof_s_spiel', 'zum Spielen'),
      "S'asseoir": phrase('prof_s_sitz', 'zum Sitzen'),
      'À emporter': phrase('prof_s_mit', 'für unterwegs'),
      'Dehors, au jardin': phrase('prof_s_drauss', 'für draußen'),
      'Bureau': phrase('prof_s_buero', 'für den Schreibtisch'),
      'Sport / fitness': phrase('prof_s_sport', 'für Sport'),
      'Yoga': phrase('prof_s_yoga', 'für Yoga'),
      'Équilibre': phrase('prof_s_bal', 'zum Balancieren'),
      'Salon': phrase('prof_s_wohn', 'fürs Wohnzimmer')
    };
    var BESTAND = {
      'A des Originals sans Board': phrase('prof_own_noboard', 'passend zu den vorhandenen Originals'),
      'A des Originals': phrase('prof_own_set', 'als Ergänzung zum vorhandenen Set'),
      'A une assise (Base / Dynamic)': phrase('prof_own_seat', 'als Ergänzung zum vorhandenen Hocker'),
      'A seulement des Inside': phrase('prof_own_inside', 'passend zu den vorhandenen Inside-Schalen'),
      'A seulement des Mini': phrase('prof_own_mini', 'passend zu den vorhandenen Minis')
    };
    var app = root.querySelector('[data-gq-app]');
    var nlForm = root.querySelector('[data-gq-nlform]');
    var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || C.currency || 'EUR';
    var money = function (n) { try { return new Intl.NumberFormat('de-DE', {style: 'currency', currency: currency, minimumFractionDigits: n % 1 ? 2 : 0}).format(n); } catch (e) { return n + ' €'; } };
    var GE = window.GeschenkefinderEngine;
    if (!GE || !app) return;

    /* ---------- copy ---------- */
    var TEXT = {};  // engine key -> {name, name_ws, reason, short}
    (C.texts || []).forEach(function (b) { if (b.key) TEXT[b.key] = b; });
    var WHO = [[T.who_kind, "Mon enfant ou mes enfants"], [T.who_enkel, "Mes petits-enfants"], [T.who_pate, "Filleul·e, nièce, neveu"], [T.who_freunde, "Enfant d'ami·es"], [T.who_erw, "Une personne adulte"]];
    var COUNT = [[T.count_1, 1], [T.count_2, 2], [T.count_3, 3], [T.count_4, 4]];
    var AGES = [[T.age_0, 0], [T.age_1, 1], [T.age_3, 3], [T.age_6, 6], [T.age_10, 10]];
    var OWNS = [[T.owns_yes, 'oui'], [T.owns_no, 'non'], [T.owns_unknown, 'ne sait pas']];
    var USES_CHILD = [[T.use_bew, 'Bouger'], [T.use_spiel, 'Jouer'], [T.use_sitz, "S'asseoir"], [T.use_mit, 'À emporter'], [T.use_drauss, 'Dehors, au jardin']];
    var USES_ADULT = [[T.use_buero, 'Bureau'], [T.use_sport, 'Sport / fitness'], [T.use_yoga, 'Yoga'], [T.use_bal, 'Équilibre'], [T.use_wohn, 'Salon']];
    var BUDGET = [[T.budget_1, "jusqu'à 100 €"], [T.budget_2, '100 à 200 €'], [T.budget_3, '200 à 300 €'], [T.budget_4, 'plus de 300 €']];
    var OWN_LBL = String(T.owned_list || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean);

    /* ---------- Winter Special switch: one date constant + ?ws=1 / ?ws=0 for QA ---------- */
    var qs = new URLSearchParams(location.search);
    var WS_END = C.ws_end || '2026-11-01';
    var WS = qs.get('ws') === '1' ? true : qs.get('ws') === '0' ? false : berlinToday() <= WS_END;
    var handleFor = function (k) { return (WS && HANDLES_WS[k]) ? HANDLES_WS[k] : HANDLES[k]; };
    var nameFor = function (k) { var t = TEXT[k] || {}; return (WS && HANDLES_WS[k]) ? (t.name_ws || t.name || k) : (t.name || k); };

    /* ---------- catalog: section product list, then /products/<handle>.js for anything missing ---------- */
    var CAT = {};
    (readJSON(root, '[data-gq-catalog]') || []).forEach(function (p) { CAT[p.handle] = p; });
    function fromJs(p) {
      var u = function (x) { return x ? (x.indexOf('//') === 0 ? 'https:' + x : x) : null; };
      return {handle: p.handle, title: p.title, img: u(p.featured_image), variants: p.variants.map(function (v) { return {id: v.id, title: v.title, price: v.price, available: v.available, img: v.featured_image ? u(v.featured_image.src) : null}; })};
    }
    function ensure(handles) {
      var miss = handles.filter(function (h) { return h && !CAT[h]; }).filter(function (h, i, a) { return a.indexOf(h) === i; });
      return Promise.all(miss.map(function (h) {
        return fetch(routes + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p) CAT[h] = fromJs(p); }).catch(function () {});
      }));
    }
    function allHandles() {
      var hs = Object.keys(HANDLES).map(function (k) { return handleFor(k); });
      return hs.concat(OWN_IMG.filter(Boolean));
    }
    function variantsOf(h) {
      var p = CAT[h]; if (!p) return [];
      /* the standard products carry old "winter special" variants: never offer them there */
      return p.variants.filter(function (v) { return h.indexOf('winter-special') > -1 || !/^winter special/i.test(v.title); });
    }
    function available(k) { return variantsOf(handleFor(k)).some(function (v) { return v.available; }); }

    /* ---------- engine: fresh instance per decision, live prices, unavailable products pruned ---------- */
    function makeEngine() {
      var e = GE.create();
      e.setWinterSpecial(WS);
      var VAR = e.data.var, prices = {};
      Object.keys(HANDLES).forEach(function (k) {
        var vs = variantsOf(handleFor(k)); if (!vs.length) return;
        var def = (!(WS && HANDLES_WS[k]) && VAR[k] && vs.filter(function (v) { return v.id === VAR[k].id; })[0]) || vs.filter(function (v) { return v.available; })[0] || vs[0];
        prices[k] = def.price / 100;
      });
      e.setPrices(prices);
      /* brief: if a product cannot be bought online, fall back to the next candidate in the engine */
      var PROD = e.data.prod;
      Object.keys(PROD).forEach(function (pk) {
        if (partsOf(pk).some(function (x) { return HANDLES[x.n] && !available(x.n); })) delete PROD[pk];
      });
      return e;
    }

    /* ---------- state ---------- */
    var KEY = 'gq-state-' + (C.section_id || '');
    var SESSION = (load('gq-session') || Math.random().toString(36).slice(2, 10)); store('gq-session', SESSION);
    var st = {}, at = 'start', last = null, pick = {}, whichOpen = false;
    var youngest = function () { return st.ages && st.ages.length ? Math.min.apply(null, st.ages) : null; };
    var isAdult = function () { return st.who === 'Une personne adulte' || youngest() === 10; };
    function steps() {
      var s = ['who'];
      if (st.who && st.who !== 'Une personne adulte') s.push('count', 'ages');
      if (st.who && !isAdult()) { s.push('owns'); if (st.owns === 'oui') s.push('which'); }
      s.push('uses', 'budget');
      return s;
    }
    function go(id, noFocus) {
      at = id; render();
      if (!noFocus) { var h = app.querySelector('[data-gq-focus]'); if (h) h.focus({preventScroll: true}); var top = root.getBoundingClientRect().top + window.scrollY - 120; if (window.scrollY > top) window.scrollTo({top: Math.max(top, 0)}); }
      if (id !== 'start' && id !== 'result') publish('geschenkefinder_step', {step: id});
    }
    function next() { var S = steps(), i = S.indexOf(at); if (i < S.length - 1) go(S[i + 1]); else showResult(); }
    function back() { if (at === 'result') { var S = steps(); go(S[S.length - 1]); return; } var S2 = steps(), i = S2.indexOf(at); go(i > 0 ? S2[i - 1] : 'start'); }
    function setAnswer(k, v) {
      var was = isAdult(); st[k] = v;
      if ((k === 'who' || k === 'ages') && isAdult() !== was) delete st.uses;
      if (k === 'count' && st.ages) st.ages = st.ages.slice(0, v);
    }

    /* ---------- rendering ---------- */
    function frame(inner) {
      var S = steps(), i = S.indexOf(at), res = at === 'result';
      var pct = res ? 100 : Math.round((i + 1) / (S.length + 1) * 100);
      return '<div class="c-gq__top"><button type="button" class="c-gq__back" data-gq-back>' + esc(T.back) + '</button>' +
        '<div class="c-gq__prog" role="progressbar" aria-label="' + esc(T.progress) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></div>' +
        '<span class="c-gq__count">' + (res ? '' : (i + 1) + ' / ' + S.length) + '</span></div><div class="c-gq__screen">' + inner + '</div>';
    }
    function heading(text, lvl) { return '<h' + (lvl || 2) + ' class="c-gq__q" tabindex="-1" data-gq-focus>' + esc(text) + '</h' + (lvl || 2) + '>'; }
    function single(q, opts, cur) {
      return frame(heading(q) + '<div class="c-gq__opts" role="group" aria-label="' + esc(q) + '">' + opts.map(function (o, i) {
        return '<button type="button" class="c-gq__opt" data-i="' + i + '" aria-pressed="' + (cur === o[1]) + '">' + esc(o[0]) + '</button>';
      }).join('') + '</div>');
    }
    function img(url, alt, w) {
      var src = url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600) : '';
      return '<span class="c-gq__media">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" loading="lazy" width="300" height="300">' : '') + '</span>';
    }

    function render() {
      if (at === 'start') {
        var hero = WS ? C.ws_image : C.start_image;
        app.innerHTML = '<div class="c-gq__start">' + (hero ? '<div class="c-gq__hero"><img src="' + esc(hero) + '" alt="' + esc(WS ? C.ws_image_alt : C.start_image_alt) + '" width="1200" height="900"></div>' : '') +
          '<div class="c-gq__startcopy">' + (T.eyebrow ? '<p class="c-gq__eyebrow">' + esc(T.eyebrow) + '</p>' : '') + heading(T.start_heading, 1) +
          '<p class="c-gq__lead">' + esc(T.start_text) + '</p><div><button type="button" class="c-gq__btn" data-gq-start>' + esc(T.start_button) + '</button></div></div></div>';
        app.querySelector('[data-gq-start]').onclick = function () { publish('geschenkefinder_start', {}); go('who'); };
        ensure(allHandles());
        return;
      }
      if (at === 'who' || at === 'count' || at === 'owns' || at === 'budget') {
        var conf = {who: [T.q_who, WHO], count: [T.q_count, COUNT], owns: [T.q_owns, OWNS], budget: [T.q_budget, BUDGET]}[at];
        app.innerHTML = single(conf[0], conf[1], st[at]);
        app.querySelectorAll('.c-gq__opt').forEach(function (b) { b.onclick = function () { setAnswer(at, conf[1][+b.dataset.i][1]); next(); }; });
      }
      if (at === 'ages') {
        var n = st.count || 1, sel = (st.ages || []).slice(0, n);
        var kids = '';
        for (var k = 0; k < n; k++) {
          kids += '<div class="c-gq__kid"><span class="c-gq__kidl" id="gq-kl' + k + '-' + C.section_id + '">' + esc(n > 1 ? T.child_label + ' ' + (k + 1) : T.age_label) + '</span><div class="c-gq__chips" role="group" aria-labelledby="gq-kl' + k + '-' + C.section_id + '">' +
            AGES.map(function (a) { return '<button type="button" class="c-gq__chip" data-k="' + k + '" data-a="' + a[1] + '" aria-pressed="' + (sel[k] === a[1]) + '">' + esc(a[0]) + '</button>'; }).join('') + '</div></div>';
        }
        app.innerHTML = frame(heading(n > 1 ? T.q_age_many : T.q_age_one) + (n > 1 ? '<p class="c-gq__hint">' + esc(T.age_hint) + '</p>' : '') +
          '<div class="c-gq__kids">' + kids + '</div><p class="c-gq__err" data-gq-err role="alert"></p><button type="button" class="c-gq__btn c-gq__btn--wide" data-gq-ok>' + esc(T.next) + '</button>');
        app.querySelectorAll('.c-gq__chip').forEach(function (c) {
          c.onclick = function () {
            var kk = +c.dataset.k; sel[kk] = +c.dataset.a;
            app.querySelectorAll('.c-gq__chip[data-k="' + kk + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
            if (n === 1) { setAnswer('ages', sel.slice()); next(); }
          };
        });
        app.querySelector('[data-gq-ok]').onclick = function () {
          if (sel.filter(function (x) { return x != null; }).length < n) { app.querySelector('[data-gq-err]').textContent = T.age_error; return; }
          setAnswer('ages', sel.slice(0, n)); next();
        };
      }
      if (at === 'which' || at === 'uses') {
        var isW = at === 'which', eng0 = GE.create(), opts, q, hint;
        if (isW) { opts = eng0.own.map(function (v, i) { return [OWN_LBL[i] || v, v, OWN_IMG[i]]; }); q = T.q_which; hint = T.which_hint; }
        else { opts = isAdult() ? USES_ADULT : USES_CHILD; q = T.q_uses; hint = T.uses_hint; }
        var cur = {}; (st[at] || []).forEach(function (v) { cur[v] = true; });
        if (isW && (st.which || []).some(function (v) { return eng0.own.indexOf(v) >= 8; })) whichOpen = true;
        var btn = function (o, i) {
          var hidden = isW && i >= 8 && !whichOpen;
          if (isW) return '<button type="button" class="c-gq__opt c-gq__opt--thumb" data-v="' + i + '" aria-pressed="' + !!cur[o[1]] + '"' + (hidden ? ' hidden' : '') + '>' + img(o[2] && CAT[o[2]] ? CAT[o[2]].img : null, '', 300) + '<span class="c-gq__optl"><span class="c-gq__box" aria-hidden="true"></span>' + esc(o[0]) + '</span></button>';
          return '<button type="button" class="c-gq__opt" data-v="' + i + '" aria-pressed="' + !!cur[o[1]] + '"><span class="c-gq__box" aria-hidden="true"></span>' + esc(o[0]) + '</button>';
        };
        var body = isW ? '<span class="c-gq__group">' + esc(T.which_sets) + '</span>' + opts.slice(0, 4).map(btn).join('') + '<span class="c-gq__group">' + esc(T.which_single) + '</span>' + opts.slice(4).map(function (o, i) { return btn(o, i + 4); }).join('') : opts.map(btn).join('');
        app.innerHTML = frame(heading(q) + (hint ? '<p class="c-gq__hint">' + esc(hint) + '</p>' : '') + '<div class="c-gq__opts' + (isW ? ' c-gq__opts--grid' : '') + '" role="group" aria-label="' + esc(q) + '">' + body + '</div>' +
          (isW && !whichOpen ? '<button type="button" class="c-gq__link" data-gq-more>' + esc(T.which_more) + '</button>' : '') +
          '<p class="c-gq__err" data-gq-err role="alert"></p><button type="button" class="c-gq__btn c-gq__btn--wide" data-gq-ok>' + esc(T.next) + '</button>');
        if (isW) ensure(OWN_IMG.filter(Boolean)).then(function () {
          app.querySelectorAll('.c-gq__opt--thumb').forEach(function (b) { var h = OWN_IMG[+b.dataset.v], m = b.querySelector('.c-gq__media'); if (h && CAT[h] && m && !m.querySelector('img')) m.innerHTML = '<img src="' + esc(CAT[h].img + (CAT[h].img.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '" alt="" loading="lazy" width="300" height="300">'; });
        });
        app.querySelectorAll('.c-gq__opts .c-gq__opt').forEach(function (b) {
          b.onclick = function () { var v = opts[+b.dataset.v][1]; cur[v] = !cur[v]; b.setAttribute('aria-pressed', !!cur[v]); app.querySelector('[data-gq-err]').textContent = ''; };
        });
        var more = app.querySelector('[data-gq-more]');
        if (more) more.onclick = function () { whichOpen = true; app.querySelectorAll('.c-gq__opts [hidden]').forEach(function (x) { x.hidden = false; }); more.remove(); };
        app.querySelector('[data-gq-ok]').onclick = function () {
          var v = opts.map(function (o) { return o[1]; }).filter(function (x) { return cur[x]; });
          if (!isW && !v.length) { app.querySelector('[data-gq-err]').textContent = T.uses_error; return; }
          st[at] = v; next();
        };
      }
      if (at === 'result') renderResult();
      var b = app.querySelector('[data-gq-back]'); if (b) b.onclick = back;
      parkForm();
    }

    /* ---------- newsletter (end of the result screen) ----------
       {% form 'customer' %} posted in the background so the result stays on screen. If Shopify
       answers with its captcha page, the form is posted natively instead; the answers survive
       that reload in sessionStorage. Double opt-in stays on: we tell people to confirm by email. */
    var nlState = '';   // '' | 'done' | 'error'
    function parkForm() { if (nlForm && !app.contains(nlForm) && nlForm.parentNode !== root) { nlForm.hidden = true; root.appendChild(nlForm); } else if (nlForm && !app.contains(nlForm)) { nlForm.hidden = true; } }
    function nlSection() {
      if (!nlForm || !C.newsletter) return '';
      if (nlState === 'done') return '<section class="c-gq__extra c-gq__nl" role="status"><p class="c-gq__extrat">' + esc(T.nl_done_title) + '</p><p>' + esc(T.nl_done) + '</p></section>';
      return '<section class="c-gq__extra c-gq__nl"><p class="c-gq__extrat">' + esc(T.q_nl) + '</p><p class="c-gq__small">' + esc(T.nl_hint) + '</p><div data-gq-nlslot></div></section>';
    }
    function mountForm() {
      var slot = app.querySelector('[data-gq-nlslot]');
      if (!slot || !nlForm) { parkForm(); return; }
      slot.appendChild(nlForm); nlForm.hidden = false;
      var err = nlForm.querySelector('[data-gq-nlerr]'); if (err) err.textContent = nlState === 'error' ? T.nl_error : '';
    }
    if (nlForm) {
      nlForm.addEventListener('submit', function (e) {
        var input = nlForm.querySelector('input[type="email"]'), err = nlForm.querySelector('[data-gq-nlerr]'), btn = nlForm.querySelector('[type="submit"]');
        var v = (input.value || '').trim();
        e.preventDefault();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { if (err) err.textContent = T.nl_error; input.focus(); return; }
        var tags = ['newsletter', 'geschenkefinder'];
        if (C.answer_tags) {
          if (SLUG[st.who]) tags.push('gf-fuer-' + SLUG[st.who]);
          if (SLUG[st.budget]) tags.push('gf-budget-' + SLUG[st.budget]);
          (st.uses || []).forEach(function (u) { if (SLUG[u]) tags.push('gf-zweck-' + SLUG[u]); });
        }
        var t = nlForm.querySelector('[name="contact[tags]"]'); if (t) t.value = tags.join(',');
        store(KEY, {st: st, ws: WS});
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        var native = function () { nlForm.submit(); };
        fetch(nlForm.action, {method: 'POST', body: new FormData(nlForm), credentials: 'same-origin'})
          .then(function (r) {
            if (/\/challenge/.test(r.url)) { native(); return; }
            store(KEY, null);
            nlState = 'done';
            publish('geschenkefinder_newsletter', {});
            var sec = app.querySelector('.c-gq__nl');
            parkForm();
            if (sec) { sec.outerHTML = nlSection(); var s2 = app.querySelector('.c-gq__nl'); if (s2) { s2.setAttribute('tabindex', '-1'); s2.focus(); } }
          })
          .catch(native);
      });
    }

    /* ---------- result ---------- */
    function answers() {
      return {who: st.who, kids: st.who === 'Une personne adulte' ? undefined : st.ages, equip: isAdult() ? undefined : st.owns,
        owned: (!isAdult() && st.owns === 'oui') ? (st.which || []) : [], uses: st.uses, budget: st.budget};
    }
    function showResult() {
      at = 'result';
      app.innerHTML = frame('<p class="c-gq__hint" data-gq-focus tabindex="-1">' + esc(T.loading) + '</p>');
      ensure(allHandles()).then(function () {
        var e = makeEngine();
        last = e.decide(answers());
        pick = {};
        go('result');
        var reco = last.products.map(function (p) { return (p.qty > 1 ? p.qty + ' ' : '') + p.key; }).join(' + ');
        publish('geschenkefinder_reco', {reco: reco, budget: st.budget});
        sendRow(reco, {event: 'result'});
      });
    }
    function sheetLang() {
      if (C.lang) return String(C.lang).toLowerCase();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var prefix = String(root).replace(/^\/+|\/+$/g, '').split('/')[0] || '';
      if (/^[a-z]{2}(?:-[a-z]{2})?$/i.test(prefix)) return prefix.toLowerCase();
      return String((window.Shopify && Shopify.locale) || '').toLowerCase();
    }
    function sendRow(reco, extra) {
      if (!C.sheet_url) return;
      extra = extra || {};
      var added = {main: 'recommendation', addon: 'bag', 'main+addon': 'recommendation and bag', gp: 'grandparent', 'main+gp': 'recommendation and grandparent'}[extra.add] || extra.add || '';
      var includesReco = extra.clicked_reco != null ? extra.clicked_reco : (extra.event === 'add_to_cart' && /(?:^|\+)main(?:\+|$)/.test(extra.add || ''));
      var row = {event: extra.event || 'result', lang: sheetLang(), session: SESSION, who: st.who, children: st.who === 'Une personne adulte' ? '' : String((st.ages || []).length), ages: (st.ages || []).join(', '),
        owned: (!isAdult() && st.owns === 'oui') ? (st.which || []).join(', ') : '', uses: (st.uses || []).join(', '), budget: st.budget, reco: reco, add: added,
        value: extra.value == null ? '' : extra.value, currency: currency, clicked_reco: includesReco ? 1 : 0, ws: WS ? 1 : 0,
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '', utm_campaign: qs.get('utm_campaign') || ''};
      try { fetch(C.sheet_url, {method: 'POST', mode: 'no-cors', headers: {'Content-Type': 'text/plain'}, body: JSON.stringify(row)}); } catch (err) {}
    }
    function forWhom() {
      if (st.who === 'Une personne adulte') return phrase('prof_adult', 'Für eine erwachsene Person');
      var y = youngest(), n = (st.ages || []).length;
      if (y === 10) return phrase('prof_10', 'Für eine Person ab 10 Jahren');
      return (n > 1 ? FUER_MANY : FUER_ONE)[y];
    }
    function whatFor() {
      var u = st.uses || [];
      if (u.length === 1) return ZWECK_LONG[u[0]];
      var s = u.map(function (x) { return ZWECK_SHORT[x]; });
      var zum = s.filter(function (x) { return x && PRE_ZUM && x.indexOf(PRE_ZUM) === 0; }).map(function (x, i) { return i ? x.slice(PRE_ZUM.length) : x; });
      var fur = s.filter(function (x) { return x && !(PRE_ZUM && x.indexOf(PRE_ZUM) === 0); }).map(function (x, i) { return i && PRE_FUER && x.indexOf(PRE_FUER) === 0 ? x.slice(PRE_FUER.length) : x; });
      return [zum.length ? listJoin(zum) : null, fur.length ? listJoin(fur) : null].filter(Boolean).join(', ');
    }
    function itemFor(key) {
      var h = handleFor(key), vs = variantsOf(h), e = GE.create(), def = e.data.var[key];
      var defId = (WS && HANDLES_WS[key]) ? (vs[0] && vs[0].id) : (def && def.id);
      return {key: key, qty: 1, handle: h, variantId: defId};
    }
    function line(item) {
      var vs = variantsOf(item.handle), want = pick[item.handle] != null ? pick[item.handle] : item.variantId;
      var v = vs.filter(function (x) { return x.id === want && x.available; })[0] || vs.filter(function (x) { return x.available; })[0] || null;
      return {item: item, vs: vs, v: v, p: CAT[item.handle]};
    }
    function card(item) {
      var l = line(item), name = nameFor(item.key), uid = C.section_id + '-' + item.handle.replace(/[^a-z0-9]/gi, '');
      var image = l.v && l.v.img ? l.v.img : (l.p ? l.p.img : null);
      var picker = '';
      if (l.vs.length > 1 && l.vs.length <= 6) {
        picker = '<div class="c-gq__vars" role="group" aria-label="' + esc(T.colour_label + ': ' + name) + '">' + l.vs.map(function (x) {
          return '<button type="button" class="c-gq__var" data-h="' + esc(item.handle) + '" data-id="' + x.id + '" aria-pressed="' + !!(l.v && l.v.id === x.id) + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</button>';
        }).join('') + '</div>';
      } else if (l.vs.length > 6) {
        picker = '<label class="c-gq__small" for="gq-vs-' + uid + '">' + esc(T.colour_label) + '</label><select class="c-gq__select" id="gq-vs-' + uid + '" data-h="' + esc(item.handle) + '">' + l.vs.map(function (x) {
          return '<option value="' + x.id + '"' + (l.v && l.v.id === x.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (' + T.unavailable + ')') + '</option>';
        }).join('') + '</select>';
      }
      return '<article class="c-gq__card">' + img(image, name, 500) + '<div class="c-gq__cardbody">' +
        (item.qty > 1 ? '<span class="c-gq__small">' + item.qty + ' ×</span>' : '') + '<h3 class="c-gq__cardt">' + esc(name) + '</h3>' +
        '<span class="c-gq__price">' + (l.v ? money(l.v.price * item.qty / 100) : '–') + '</span>' +
        (l.v ? '' : '<span class="c-gq__na">' + esc(T.unavailable) + '</span>') + picker + '</div></article>';
    }
    function total(items) { var t = 0, ok = true; items.forEach(function (i) { var l = line(i); if (l.v) t += l.v.price * i.qty; else ok = false; }); return {t: t / 100, ok: ok}; }

    function renderResult() {
      var r = last;
      if (!r || !r.products.length) {
        app.innerHTML = frame(heading(T.res_none) + '<p class="c-gq__hint">' + esc(T.res_none_hint) + '</p>' + afterLinks());
        wireAfter(); return;
      }
      var main = r.products.map(function (p) { var it = itemFor(p.key); it.qty = p.qty; it.variantId = it.variantId || p.variantId; return it; });
      var names = main.map(function (p) { return (p.qty > 1 ? p.qty + ' × ' : '') + nameFor(p.key); }).join(' + ');
      var sentence = [forWhom(), whatFor(), r.profile ? BESTAND[r.profile] : null].filter(Boolean).join(', ') + '.';
      var reason = (TEXT[main[0].key] || {}).reason || '';
      var dazu = main.slice(1).map(function (p) { return (TEXT[p.key] || {}).short || nameFor(p.key); });
      var tot = total(main);
      var addon = r.addon && !main.some(function (p) { return p.key === r.addon; }) && available(r.addon) ? itemFor(r.addon) : null;
      var gp = r.grandparentUpsell && available('Dynamic all') ? itemFor('Dynamic all') : null;
      app.innerHTML = frame(
        '<p class="c-gq__eyebrow">' + esc(T.res_eyebrow) + '</p>' + heading(T.res_title + ' ' + names, 2) +
        '<div class="c-gq__say"><p class="c-gq__lead">' + esc(sentence) + '</p>' + (reason ? '<p>' + esc(reason) + '</p>' : '') + (dazu.length ? '<p>' + esc(T.res_dazu + ' ' + listJoin(dazu)) + '.</p>' : '') + '</div>' +
        '<div class="c-gq__cards" data-gq-reco>' + main.map(card).join('') + '</div>' +
        (r.aboveBand ? '<p class="c-gq__note">' + esc(T.res_above_note) + '</p>' : '') +
        '<div class="c-gq__total"><span>' + esc(main.length > 1 || main[0].qty > 1 ? T.res_total_many : T.res_total_one) + '</span><strong>' + (r.aboveBand ? esc(T.res_from) + ' ' : '') + money(tot.t) + '</strong></div>' +
        '<p class="c-gq__err" data-gq-carterr role="alert"></p>' +
        '<button type="button" class="c-gq__btn c-gq__btn--wide" data-gq-add="main"' + (tot.ok ? '' : ' disabled') + '>' + esc(T.res_cart) + '</button>' +
        (addon ? '<section class="c-gq__extra"><p class="c-gq__extrat">' + esc(T.res_bag + ' ' + nameFor(addon.key)) + '</p><div class="c-gq__cards">' + card(addon) + '</div><div class="c-gq__btns"><button type="button" class="c-gq__btn c-gq__btn--ghost" data-gq-add="addon">' + esc(T.res_cart) + '</button><button type="button" class="c-gq__btn" data-gq-add="main+addon"' + (tot.ok ? '' : ' disabled') + '>' + esc(T.res_both) + '</button></div></section>' : '') +
        (gp ? '<section class="c-gq__extra"><p class="c-gq__extrat">' + esc(T.res_gp + ' ' + nameFor('Dynamic all')) + '</p><div class="c-gq__cards">' + card(gp) + '</div><div class="c-gq__btns"><button type="button" class="c-gq__btn c-gq__btn--ghost" data-gq-add="gp">' + esc(T.res_cart) + '</button><button type="button" class="c-gq__btn" data-gq-add="main+gp"' + (tot.ok ? '' : ' disabled') + '>' + esc(T.res_both) + '</button></div></section>' : '') +
        nlSection() + afterLinks());
      mountForm();
      app.querySelectorAll('.c-gq__var').forEach(function (b) { b.onclick = function () { pick[b.dataset.h] = +b.dataset.id; renderResult(); }; });
      app.querySelectorAll('.c-gq__select').forEach(function (s) { s.onchange = function () { pick[s.dataset.h] = +s.value; renderResult(); var again = document.getElementById(s.id); if (again) again.focus(); }; });
      var recoKey = r.products.map(function (p) { return (p.qty > 1 ? p.qty + ' ' : '') + p.key; }).join(' + ');
      var sets = {main: main, addon: addon ? [addon] : [], gp: gp ? [gp] : []};
      app.querySelectorAll('[data-gq-add]').forEach(function (b) {
        b.onclick = function () { var items = []; b.dataset.gqAdd.split('+').forEach(function (k) { items = items.concat(sets[k] || []); }); addToCart(items, recoKey, b, b.dataset.gqAdd); };
      });
      var recoCards = app.querySelector('[data-gq-reco]');
      if (recoCards) recoCards.addEventListener('click', function (e) {
        if (e.target.closest('button, select, a, label')) return;
        sendRow(recoKey, {event: 'click_reco', clicked_reco: 1});
      });
      wireAfter();
      var bb = app.querySelector('[data-gq-back]'); if (bb) bb.onclick = back;
    }
    function afterLinks() { return '<div class="c-gq__after"><button type="button" class="c-gq__link" data-gq-change>' + esc(T.res_change) + '</button><button type="button" class="c-gq__link" data-gq-restart>' + esc(T.res_restart) + '</button></div>'; }
    function wireAfter() {
      var c = app.querySelector('[data-gq-change]'), r = app.querySelector('[data-gq-restart]');
      if (c) c.onclick = function () { go('who'); };
      if (r) r.onclick = function () { st = {}; whichOpen = false; store(KEY, null); go('start'); };
      var b = app.querySelector('[data-gq-back]'); if (b) b.onclick = back;
    }

    /* ---------- cart: one /cart/add.js call, hidden line property, answers as cart attribute ---------- */
    function addToCart(items, recoKey, btn, addKind) {
      var lines = items.map(line).filter(function (l) { return l.v; });
      if (!lines.length) return;
      var err = app.querySelector('[data-gq-carterr]');
      btn.disabled = true; btn.classList.add('is-loading');
      var payload = {items: lines.map(function (l) { return {id: l.v.id, quantity: l.item.qty, properties: {_geschenkefinder: recoKey}}; })};
      var value = lines.reduce(function (s, l) { return s + l.v.price * l.item.qty; }, 0) / 100;
      var summary = ['fuer=' + (SLUG[st.who] || ''), 'alter=' + (st.ages || []).join('/'), 'hat=' + (isAdult() ? '' : st.owns === 'oui' ? (st.which || []).length + ' Produkte' : st.owns === 'non' ? 'nein' : 'unbekannt'),
        'zweck=' + (st.uses || []).map(function (u) { return SLUG[u]; }).join('/'), 'budget=' + (SLUG[st.budget] || ''), 'idee=' + recoKey, 'ws=' + (WS ? 1 : 0), 'session=' + SESSION].join('; ');
      fetch(routes + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(payload)})
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); })
        .then(function () {
          if (!C.cart_attribute) return null;
          return fetch(routes + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({attributes: {_geschenkefinder: summary}})}).catch(function () {});
        })
        .then(function () {
          publish('geschenkefinder_add_to_cart', {reco: recoKey, value: value, currency: currency});
          sendRow(recoKey, {event: 'add_to_cart', add: addKind || '', value: value});
          btn.disabled = false; btn.classList.remove('is-loading');
          var drawer = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
          if (drawer && typeof drawer.update === 'function') { drawer.update(); if (typeof drawer.open === 'function') drawer.open(); }
          else { window.location.href = routes + 'cart'; }
        })
        .catch(function (e) {
          btn.disabled = false; btn.classList.remove('is-loading');
          if (err) err.textContent = T.cart_error + (e && e.message && e.message !== 'error' ? ' (' + e.message + ')' : '');
        });
    }

    /* ---------- boot: back from the newsletter form reload? ---------- */
    var saved = load(KEY);
    var posted = !!root.querySelector('[data-gq-posted]') || qs.get('customer_posted') === 'true';
    var nlErr = !!root.querySelector('[data-gq-nlerror]');
    if (saved && (posted || nlErr)) {
      st = saved.st || {}; WS = saved.ws != null ? saved.ws : WS; store(KEY, null);
      nlState = posted ? 'done' : 'error';
      if (posted) publish('geschenkefinder_newsletter', {});
      showResult();
      root.scrollIntoView({block: 'start'});
    } else {
      render();
    }
  }

  function boot() { document.querySelectorAll('[data-gq-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-gq-root]'); if (r) init(r); });
})();
